<template>
  <bridge-form
    mode="create"
    @submit="handleSubmit"
  />
</template>

<script>
  import { BridgeForm } from '../../components'
  import { useCreateBridge } from './bridgeHooks'

  export default {
    name: 'AddBridge',
    components: { BridgeForm },
    mixins: [
      useCreateBridge('handleSubmit'),
    ],
  }
</script>

<style scoped>

</style>
